import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ChatInput from "./components/ChatInput";
import SendButton from "./components/SendButton";
import { onLoadChat, onClickSend, updateChat } from "./features/ChatActions";
import { withChatContext } from "./Context";
import { CHAT_STATUS } from "./constants";

class ChatInputContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserTyping: false
    };
    this.onSendClick = this.onSendClick.bind(this);
    this.onChatChange = this.onChatChange.bind(this); // NOTE: Removed due to Live issue
    // this.handleTyping = _.debounce(this.handleTyping.bind(this), 750);

    let silentMessage = "welcome";

    if (this.props.chat.chatBot.alreadyWelcomed) {
      silentMessage = "welcome-back";
    }

    if (this.props.chat.config.flag === "inflight-success") {
      silentMessage = "inflight-success";
    }

    this.props.dispatch(onLoadChat({
      message: "",
      parcelCode: this.props.chat.config.parcelCode,
      init: true,
      silentMessage,
      apiClient: this.props.apiClient
    }));
  } // NOTE: Removed due to Live issue
  // handleTyping({ dispatch, apiClient, isTyping }) {
  //  dispatch(updateChasitorTyping(apiClient, isTyping));
  //  this.setState({ isUserTyping: isTyping });
  // }


  onSendClick() {
    this.props.dispatch(onClickSend({
      message: this.props.chat.chatBot.currentMessage,
      parcelCode: this.props.chat.config.parcelCode,
      apiClient: this.props.apiClient
    }));
  }

  onChatChange(message) {
    // NOTE: Removed due to Live issue
    // const { dispatch, apiClient } = this.props;
    // if (!this.state.isUserTyping) {
    //  dispatch(updateChasitorTyping(apiClient, true));
    //  this.setState({ isUserTyping: true });
    // }
    // this.handleTyping({
    //  dispatch,
    //  apiClient,
    //  isTyping: false,
    // });
    this.props.dispatch(updateChat(message));
  }

  render() {
    const isDisabled = this.props.chat.chatBot.state === CHAT_STATUS.ADVISOR_ENDED;
    return /*#__PURE__*/React.createElement("div", {
      id: "chat-input"
    }, /*#__PURE__*/React.createElement(ChatInput, {
      ref: re => {
        this.inputRef = re;
      },
      onChange: this.onChatChange,
      onSubmit: this.onSendClick,
      value: this.props.chat.chatBot.currentMessage,
      disabled: isDisabled
    }), /*#__PURE__*/React.createElement(SendButton, {
      onClick: this.onSendClick,
      disabled: isDisabled
    }));
  }

}

ChatInputContainer.propTypes = {
  dispatch: PropTypes.func,
  config: PropTypes.object,
  chat: PropTypes.object,
  apiClient: PropTypes.object
};

function mapStateToProps(state) {
  return state;
}

export default withChatContext(connect(mapStateToProps)(ChatInputContainer));